import { useEffect, useRef } from 'react';
import './KitSignup.css';

const FORM_UID = '8650cefb3b';

function styleForm(form: HTMLFormElement) {
  form.setAttribute('aria-label', 'Kostenloses Workbook herunterladen');

  const fields = [
    { name: 'fields[first_name]', id: 'kit-name', label: 'Name', placeholder: 'Dein Name', autoComplete: 'given-name' },
    { name: 'email_address', id: 'kit-email', label: 'E-Mail', placeholder: 'deine@email.de', autoComplete: 'email' },
  ];

  fields.forEach(({ name, id, label: text, placeholder, autoComplete }) => {
    const input = form.querySelector<HTMLInputElement>(`input[name="${name}"]`);
    if (!input) return;

    input.id = id;
    input.placeholder = placeholder;
    input.autocomplete = autoComplete;
    input.setAttribute('aria-label', text);
    if (name === 'email_address') input.type = 'email';

    if (!form.querySelector(`label[for="${id}"]`)) {
      const label = document.createElement('label');
      label.htmlFor = id;
      label.textContent = text;
      input.before(label);
    }
  });

  const button = form.querySelector<HTMLButtonElement>('[data-element="submit"]');
  const caption = button?.querySelector('span');
  if (button && caption) {
    button.classList.add('brand-button');
    const strong = document.createElement('strong');
    strong.textContent = 'Kostenlos';
    caption.replaceChildren(strong, document.createTextNode(' herunterladen'));
  }
}

export default function KitSignup() {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    // Kit inserts its own form and retains control of validation and submission.
    const applyDesign = () => {
      const form = container.querySelector<HTMLFormElement>(`form[data-uid="${FORM_UID}"]`);
      if (!form) return false;
      styleForm(form);
      return true;
    };

    if (applyDesign()) return;

    const observer = new MutationObserver(() => {
      if (applyDesign()) observer.disconnect();
    });
    observer.observe(container, { childList: true, subtree: true });

    if (!container.querySelector(`script[data-uid="${FORM_UID}"]`)) {
      const script = document.createElement('script');
      script.src = `https://kevin-chromik.kit.com/${FORM_UID}/index.js`;
      script.async = true;
      script.dataset.uid = FORM_UID;
      container.appendChild(script);
    }

    return () => observer.disconnect();
  }, []);

  return <div id="workbook-signup" ref={containerRef} />;
}
